import type { EexCapabilities, EexAccessOverrides, FinanceFunction, FinanceTab, UserRole } from "@chro/shared";

export type Company = {
  id: string;
  name: string;
  slug: string;
  eexEnabled: boolean;
  tradingEnabled: boolean;
  forecastingEnabled: boolean;
  brmEnabled: boolean;
  disabledAt: string | null;
};

export type AdminUser = {
  id: string;
  email: string;
  displayName: string | null;
  role: UserRole;
  companyId: string | null;
  eexEnabled: boolean;
  eexFinanceTabs?: FinanceTab[];
  eexFinanceFunctions?: FinanceFunction[];
  eexCapabilities?: EexCapabilities;
  eexAccessOverrides?: EexAccessOverrides;
  eexEditPermission: "none" | "requires_approval" | "free";
  tradingEnabled: boolean;
  forecastingEnabled: boolean;
  brmEnabled: boolean;
  disabledAt: string | null;
  mustChangePassword: boolean;
};

// The per-company / per-user module entitlement flags, in display order.
export const MODULE_TOGGLES = [
  { key: "eexEnabled", label: "EEX" },
  { key: "tradingEnabled", label: "Trading" },
  { key: "forecastingEnabled", label: "Forecasting" },
  { key: "brmEnabled", label: "BRM" },
] as const;
export type ModuleToggleKey = (typeof MODULE_TOGGLES)[number]["key"];

export const COMPANY_ROLES: Array<Exclude<UserRole, "global_admin">> = [
  "company_admin",
  "trader",
  "risk",
  "finance",
  "viewer",
];

export const ROLE_LABELS: Record<UserRole, string> = {
  global_admin: "Global admin",
  company_admin: "Company admin",
  trader: "Trader",
  risk: "Risk",
  finance: "Finance",
  viewer: "Viewer",
};

export function roleLabel(role: UserRole): string {
  return ROLE_LABELS[role] ?? role;
}

export function SectionTitle({ icon, title }: { icon: React.ReactNode; title: string }) {
  return (
    <div className="ops-section-title flex items-center gap-2 text-sm font-semibold">
      {icon}
      {title}
    </div>
  );
}
